export const BFF_SERVICE_PATH = `/experience-bff-service`
export const PRODUCT_JOURNEY_GIRAR = `/product-journey-girar/building`
